export enum RolesAndPermissions {
  AdminRoleName = 'Administrator',
  TripRead = 'Trip.Read',
  TripEdit = 'Trip.Edit',
  TripShowInMap = 'Trip.ShowInMap',
  TripShowOnlyMine = 'Trip.ShowOnlyMine',
  TripExpenseSettingsRead = 'Settings.Trip.Expense.Read',
  TripExpenseSettingsEdit = 'Settings.Trip.Expense.Edit',
  TripFuelSettingsRead = 'Settings.Trip.Fuel.Read',
  TripFuelSettingsEdit = 'Settings.Trip.Fuel.Edit',
  TripSettingsTypeSetupRead = 'Settings.Trip.TripType.Read',
  TripSettingsTypeSetupEdit = 'Settings.Trip.TripType.Edit',
  TripSettingsTypeSetupDelete = 'Settings.Trip.TripType.Delete',
  AssetRead = 'Asset.Read',
  AssetEdit = 'Asset.Edit',
  AssetDelete = 'Asset.Delete',
  AssetShowInMap = 'Asset.ShowInMap',
  AssetTypeSettingsRead = 'Settings.Asset.Type.Read',
  AssetTypeSettingsEdit = 'Settings.Asset.Type.Edit',
  AssetTypeSettingsDelete = 'Settings.Asset.Type.Delete',
  AlertSettingsRead = 'Settings.Alert.Read',
  AlertSettingsEdit = 'Settings.Alert.Edit',
  AssetEditRestricted = 'Asset.EditRestricted',
  AssetLocationSettingsRead = 'Settings.AssetLocation.Read',
  AssetLocationSettingsEdit = 'Settings.AssetLocation.Edit',
  AssetLocationSettingsDelete = 'Settings.AssetLocation.Delete',
  DepartmentSettingsRead = 'Settings.Department.Read',
  DepartmentSettingsEdit = 'Settings.Department.Edit',
  DepartmentSettingsDelete = 'Settings.Department.Delete',
  IntegrationSettingsRead = 'Settings.Integration.Read',
  IntegrationSettingsEdit = 'Settings.Integration.Edit',
  SettingsRead = 'Settings.Read',
  SettingsEdit = 'Settings.Edit',
  FindSettingsRead = 'Settings.Find.Read',
  FindSettingsEdit = 'Settings.Find.Edit',
  FindSettingsDelete = 'Settings.Find.Delete',
  POIRead = 'POI.Read',
  POIEdit = 'POI.Edit',
  POIDelete = 'POI.Delete',
  StatisticsRead = 'Statistic.Read',
  UserAddAll = 'User.AddAll',
  UserRead = 'User.Read',
  UserEdit = 'User.Edit',
  UserDelete = 'User.Delete',
  UserLogRead = 'User.UserLog.Read',
  VehicleAdjustMileageEdit = 'Vehicle.AdjustMileage.Edit',
  VehicleAdjustMileageRead = 'Vehicle.AdjustMileage.Read',
  VehicleRead = 'Vehicle.Read',
  VehicleEdit = 'Vehicle.Edit',
  VehicleDelete = 'Vehicle.Delete',
  VehicleShowInMap = 'Vehicle.ShowInMap',
  VehicleShowDeleted = 'Vehicle.ShowDeleted',
  VehicleEditMyPrivate = 'Vehicle.Edit.MyPrivate',
  RoleSettingsDelete = 'Settings.Role.Delete',
  RoleSettingsEdit = 'Settings.Role.Edit',
  RoleSettingsRead = 'Settings.Role.Read',
  TrackerSettingsEdit = 'Settings.Tracker.Edit',
  TrackerSettingsRead = 'Settings.Tracker.Read',
  CardReaderSettingsEdit = 'Settings.CardReader.Edit',
  CardReaderSettingsRead = 'Settings.CardReader.Read',
  KeyfobSettingsEdit = 'Settings.Keyfob.Edit',
  KeyfobSettingsRead = 'Settings.Keyfob.Read',
  ReportRead = 'Report.Read',
  ReportEdit = 'Report.Edit',
  ReportDelete = 'Report.Delete',
  UserLogSettingsRead = 'Settings.UserLog.Read',
  FilterEditExtended = 'Filter.EditExtended',
  EmissionRead = 'Emission.Read',
  StandbyRead = 'Standby.Read',
  StandbyEdit = 'Standby.Edit',
  StandbySettingsEdit = 'Settings.Standby.Edit',
  StandbyLocationSettingsRead = 'Settings.Standby.Location.Read',
  StandbyLocationSettingsEdit = 'Settings.Standby.Location.Edit',
  StandbyLogSettingsRead = 'Settings.Standby.Log.Read',
  StandbyLogSettingShowOnlyMine = 'Settings.Standby.Log.ShowOnlyMine',
  FleetRead = 'Fleet.Read',
  FleetTemporaryGeofenceEdit = 'Fleet.GeofenceTemporary.Edit',
  FleetSettingsGeofenceRead = 'Settings.Fleet.Geofence.Read',
  FleetSettingsGeofenceEdit = 'Settings.Fleet.Geofence.Edit',
  DamageEdit = 'Damage.Edit',
  DamageRead = 'Damage.Read',
  DamageShowOnlyMine = 'Damage.ShowOnlyMine',
}
